module.exports = __webpack_public_path__ + "media/src/img/fond-bg-683d543b947b0603ab6cbaa100aaff61.jpg";